export enum ProgressBarOrientationEnum {
  horizontal = '',
  horizontalReverse = 'reverse',
  vertical = 'vertical',
  verticalReverse = 'vertical-reverse',
}
